export const ContentSoftware = () => {
  return (
    <main>
      <h1>Política de Conteúdo</h1>
      <p>
        <strong>Versão de 29/11/2025</strong>
      </p>

      <p>
        Esta Política de Conteúdo (“Política”) possui o objetivo de informar os
        conteúdos que não serão permitidos no site, por violar a legislação ou
        princípios e valores adotados pela Celetus.
      </p>

      <p>
        O desrespeito a esta Política poderá resultar em suspensão, bloqueio
        e/ou encerramento da licença de uso do Usuário, sem prejuízo de outras
        medidas legais cabíveis.
      </p>

      <h2>CONTEÚDO PROIBIDO</h2>

      <p>
        No site da Celetus, não serão permitidos os conteúdos abaixo listados.
      </p>

      <h3>Conteúdo físico</h3>
      <p>
        Que seja tangível, material, físico, presencial. A Celetus só aceita
        produtos digitais, ou seja, produtos intangíveis disponibilizados em
        formato eletrônico, como e-books, cursos online etc. A comercialização
        de produtos físicos não está em conformidade com as diretrizes da
        plataforma.
      </p>

      <h3>Conteúdo sem caráter educacional</h3>
      <p>
        Que não oferece valor educativo ou informativo aos usuários, não oferece
        conhecimentos relevantes, habilidades práticas ou informações que
        contribuam para o aprendizado ou desenvolvimento pessoal dos usuários.
      </p>

      <h3>Conteúdo perigoso</h3>
      <p>
        Que encoraja o usuário a praticar comportamentos arriscados e perigosos,
        que contenha tutoriais sobre a realização de atividades perigosas, como
        fabricação de explosivos caseiros ou prática de esportes radicais sem
        precauções de segurança, que incentiva os usuários a se automedicarem ou
        realizar tratamentos não comprovados cientificamente.
      </p>

      <h3>Conteúdo explícito ou violento</h3>
      <p>
        Que demonstre ou incite violência, com objetivo de chocar ou causar
        repulsa nos Usuários, o que envolve, por exemplo: acidentes, desastres
        naturais, guerras, ataques terroristas, lutas, ataques físicos, tortura,
        protestos, roubos, cadáveres, procedimentos médicos, ferimentos.
      </p>

      <h3>Conteúdo ilegal</h3>
      <p>
        Que promove o Usuário a praticar atos perigosos, que orienta como
        praticar crimes, que demonstre atos ilegais de abuso ou tortura animal,
        que promova organizações criminosas (ou seus membros), terrorismo ou
        outras atividades ilegais, que forneça orientações sobre como criar
        materiais ilegais, que promove uso de drogas ilegais, que promova a
        venda de produtos e serviços ilegais, como drogas, armas de fogo,
        explosivos, órgãos, documentos falsificados ou adulterados, tráfico
        humano, produtos subtraídos de terceiros, furtados ou roubados, ou
        quaisquer outros conteúdos ilícitos.
      </p>

      <h3>
        Conteúdo com violação de direitos de personalidade, privacidade e às
        leis de proteção de dados pessoais
      </h3>
      <p>
        Produtos que violem a intimidade, a honra, a imagem, o nome ou qualquer
        outro direito de personalidade de terceiros, listas de correio ou base
        de dados pessoais, que contenha dados pessoais não autorizados pelos
        seus titulares, dentre eles imagem, voz, nome, endereço, telefone,
        dentre outros.
      </p>

      <h3>Conteúdo sexual e/ou nudez</h3>
      <p>
        Que tenha como objetivo a estimulação sexual, com pornografia ou
        representações explícitas de atos sexuais ou nudez, ou de algum modo
        obsceno ou contrário à moral e aos bons costumes, conteúdo sexual
        envolvendo menores, relacionados à pedofilia, à prostituição ou
        similares; ou, independente do contexto, conteúdos que contenham nudez
        explícita, mesmo que sem conotação sexual.
      </p>

      <h3>Conteúdo de distribuição de imagens e vídeos sensuais</h3>
      <p>
        Relacionado a imagens ou vídeos sensuais/adultos sendo entregues pelo
        Instagram (close friends), Telegram, Área de membros, ou qualquer outra
        forma de distribuição.
      </p>

      <h3>Conteúdo de ódio</h3>
      <p>
        Que promova a violência ou discriminação ou ódio a grupos ou indivíduos,
        com base em alguma característica, tal como raça, gênero, etnia,
        religião, orientação sexual, classe social, nacionalidade, dentre
        outros.
      </p>

      <h3>Conteúdo de assédio e bullying virtual (cyberbullying)</h3>
      <p>
        Que promove ameaça, perseguição (stalking), intimidação, insulto, que
        tenha linguagem abusiva ou humilhante.
      </p>

      <h3>
        Conteúdo que implique a venda ou oferta de participações societárias
        e/ou de negócios e/ou de investimentos
      </h3>
      <p>
        Conteúdo cuja finalidade seja a venda ou de participações societárias
        e/ou de negócios e/ou de investimentos, ou seja, cujo objetivo ao final
        seja angariar investidores e não promover a informação sobre produtos na
        área financeira.
      </p>

      <h3>Conteúdo com apologia do fumo</h3>
      <p>Que façam apologia do hábito de fumar.</p>

      <h3>Conteúdo de esquemas de pirâmides</h3>
      <p>Que promova esquemas de pirâmides, marketing multinível etc.</p>

      <h3>Conteúdo com promessas</h3>
      <p>
        Que promete rápida perda de peso ou enriquecimento instantâneo, limpar
        nome sujo no Serasa e similares, economia de combustível através de kit
        de hidrogênio, sucesso em loterias ou jogos de azar, cura de problemas
        de saúde sem respaldo de uma organização reconhecidamente especializada
        no tema, aumento de número de seguidores em redes sociais, curtidas,
        entre outros, que promete ganhar dinheiro com sorteios nas redes sociais
        (“Robô de Sorteios”, “Robô de Pix”) ou aplicativos autônomos.
      </p>

      <h3>Conteúdo vinculados a loterias e/ou jogos de azar</h3>
      <p>
        Produtos que estejam de qualquer forma relacionados a prática de
        apostas, loterias, cassinos ou qualquer forma de jogo de azar,
        independentemente de conter promessas ou garantias de sucesso, incluindo
        (mas não se limitando) aos de cunho educativo ou que de qualquer forma
        incentivem ou estimulem a prática. Conteúdo com violação a leis de
        propriedade intelectual: que viole direitos autorais, de marca ou de
        publicidade, segredos industriais, patentes, modelos e desenhos
        industriais.
      </p>

      <h3>Conteúdo com restrições</h3>
      <p>
        Afetados por alguma restrição de qualquer espécie quanto ao seu uso,
        exploração ou transferência de domínio ou posse. Conteúdo com problemas
        de qualidade audiovisual: que contenha imagens deturpadas, com legendas
        imprecisas ou dessincronizadas, que não sejam vídeos, ou seja, conteúdo
        com imagens estáticas que não oferecem uma experiência audiovisual
        adequada.
      </p>

      <h3>Conteúdo insuficiente para os fins propostos</h3>
      <p>
        Que tenham baixa qualidade de conteúdo educacional e que não se preste
        aos fins propostos como objetivo do Infoproduto, por negligência ou
        imperícia do Infoprodutor e/ou pelo uso de informações falsas no todo ou
        em parte do Infoproduto;
      </p>

      <h3>
        Conteúdo com anúncios publicitários enganosos, conteúdo com anúncios e
        com links externos
      </h3>
      <p>
        Que sugira ou afirme de modo indevido a existência de parceria com a
        Celetus, quando inexistente; que seja comercializado por pessoas ou
        empresas que não sejam parceiras oficiais da Celetus; que não são
        vendidos pela Celetus ou seus parceiros oficiais; que contenha apenas
        anúncios publicitários; que contenha link externo, que direcione o
        Usuário para fora do site.
      </p>

      <h3>Conteúdo relacionado à prática de Day Trade</h3>
      <p>
        Que envolva, promova ou instrua práticas de day trade, incluindo, mas
        não se limitando a estratégias de compra e venda de ativos no curto
        prazo ou qualquer outro método que busque aproveitar as variações de
        preços no curto prazo.
      </p>

      <h2>SERVIÇOS EQUIPARADOS A INFOPRODUTOS</h2>

      <p>
        Desde que respeitem os Termos Gerais de Uso e demais regras
        estabelecidas pela Celetus, são equiparados a Infoprodutos os serviços:
      </p>

      <ul>
        <li>De Consultorias e Mentorias;</li>
        <li>
          Que divulguem eventos presenciais desde que tenham cunho educacional,
          com proposta de networking, aulas, ensinamentos e/ou mentoria.
        </li>
        <li>
          De web de profissões não regulamentadas, como por exemplo, criação de
          sites, criação de marcas, edição de vídeos, social media, tráfego
          pago, gestão de perfis, consultas de tarô, mapa astral, leitura de
          vidas passadas etc..
        </li>
      </ul>

      <h2>
        SERVIÇOS QUE, A EXCLUSIVO CRITÉRIO DA CELETUS, PODEM SER EQUIPARADOS A
        INFOPRODUTOS
      </h2>

      <p>
        O Departamento de Risco da Celetus avaliará, caso a caso e a seu
        exclusivo critério, se os seguintes serviços equiparam-se a Infoprodutos
        para disponibilização na Plataforma:
      </p>

      <ul>
        <li>
          administrativos, como por exemplo, emissão de CNPJ, elaboração de
          Imposto de Renda, digitalização de documentos etc.
        </li>
        <li>
          de exercício profissional regulamentado, como por exemplo, de
          contador, advogado, arquiteto, nutricionista, personal trainner,
          terapeuta etc.
        </li>
      </ul>

      <h2>EXCEÇÕES</h2>

      <p>
        Em determinados casos, o conteúdo será permitido se o objetivo for
        educativo e desde que exista um contexto claro nos vídeos a serem
        publicados. A análise do conteúdo e sua autorização para publicação no
        site será feita exclusivamente pela Celetus e a seu exclusivo critério,
        podendo optar por vetar a disponibilização do conteúdo, se assim julgar
        apropriado.
      </p>

      <p>
        Adicionalmente, a Celetus poderá, a seu livre critério, autorizar a
        venda de produtos físicos por meio da plataforma, desde que esses
        produtos estejam em conformidade com as regras e valores da empresa.
        Tais permissões estarão sujeitas a uma avaliação caso a caso e poderão
        ser revogadas a qualquer momento, caso a Celetus entenda que os produtos
        ou conteúdos publicados não atendem aos padrões estabelecidos.
      </p>

      <h2>MUDANÇAS NA POLÍTICA DE CONTEÚDO</h2>

      <p>
        Esta Política de Conteúdo pode passar por atualizações conforme o que a
        Celetus julgar apropriado para melhorar os serviços e experiências,
        considerando seus princípios e valores. Quando houver alteração da
        Política de Conteúdo, a Celetus informará no site, em local de destaque.
      </p>

      <h2>DENÚNCIAS OU DÚVIDAS</h2>

      <p>
        Se você encontrar conteúdo que viola esta Política ou tiver dúvidas,
        comentários ou sugestões relacionadas a esta Política, entre em contato
        conosco, no seguinte e-mail:
        <a href="mailto:denuncias@celetus.com.br">
          denuncias@celetus.com.br
        </a>{' '}
        com o tema “Denúncia” ou “Política de conteúdo”.
      </p>

      <p>
        A Celetus empregará os melhores esforços para responder a todos os
        e-mails no menor espaço de tempo possível.
      </p>
    </main>
  )
}
